module.exports = __webpack_public_path__ + "img/3x.3fae5c9.jpg";